import React from "react";
var __jsx = React.createElement;
import { Button, Dialog } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { GradientButton } from 'components/common/material-ui/custom-components';
import { ButtonContainer, CloseButton, CustomText, Description, Title } from './DeleteDialog.style';

var DeleteDialog = function DeleteDialog(_ref) {
  var open = _ref.open,
      messageId = _ref.messageId,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm;
  return __jsx(Dialog, {
    open: open,
    onClose: onClose
  }, __jsx(CloseButton, {
    onClick: onClose
  }), __jsx(FormattedMessage, {
    id: "delete-modal.title",
    tagName: Title
  }), __jsx(FormattedMessage, {
    id: messageId,
    tagName: CustomText
  }), __jsx(FormattedMessage, {
    id: "delete-modal.description",
    tagName: Description
  }), __jsx(ButtonContainer, null, __jsx(Button, {
    variant: "outlined",
    color: "primary",
    onClick: onClose
  }, __jsx(FormattedMessage, {
    id: "delete-modal.cancel"
  })), __jsx(GradientButton, {
    onClick: onConfirm
  }, __jsx(FormattedMessage, {
    id: "delete-modal.delete"
  }))));
};

export default DeleteDialog;